import { PayloadEpic } from '@/store/epics/epic-types';
import { catchError, filter, map, switchMap } from 'rxjs/operators';
import { actions, asyncActions } from '@/store/slices';
import { concat, EMPTY, of } from 'rxjs';
import axios from 'axios-observable';
import { apiEndpoints } from '@/store/constants';
import { EntityId } from '@reduxjs/toolkit';

export const deleteInventoryAssetEpic: PayloadEpic<EntityId, unknown> = (action$) => {
    return action$.pipe(
        filter(asyncActions.assets.deleteAsset.match),
        switchMap(({ payload }) => concat(
            of(actions.assets.setIsDeletingAsset(true)),
            deleteComponent(payload).pipe(
                map(() => actions.assets.deleteComponent(payload)),
                catchError((error) => {
                    console.error('deleteInventoryAssetEpic', error);

                    return EMPTY;
                }),
            ),
            of(actions.assets.setIsDeletingAsset(false)),
        )),
    );
};

const deleteComponent = (componentId: EntityId) => {
    return axios.delete<unknown>(apiEndpoints.inventoryAsset(componentId));
};
